/* global axios */

export default {
  list(accountId) {
    return axios.get(`/api/v1/accounts/${accountId}/mcp_authorizations`);
  },
  create(accountId, params) {
    return axios.post(
      `/api/v1/accounts/${accountId}/mcp_authorizations`,
      params
    );
  },
  revoke(accountId, id) {
    return axios.delete(
      `/api/v1/accounts/${accountId}/mcp_authorizations/${id}`
    );
  },
};
